import React from 'react';
import {
  List,
  ListItem,
  Avatar,
  Checkbox,
  Divider, DropDownMenu, MenuItem,
} from 'material-ui';
import { connect } from 'react-redux';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import { Form } from 'react-form';
import animateScrollTo from 'animated-scroll-to';
import { injectIntl } from 'react-intl';
import ReactTooltip from 'react-tooltip';

import Translate from 'translate';
import { toggleLoading, toggleAlertError, updateUser, changeStatusWebsocket } from 'stores/actions';
import { Text } from 'components/FormElements';
import ChannelsSearch from 'routes/app/components/Agent/ChannelsSearch';
import checkbox from 'assets/images/checkbox.svg'
import ChatService from "services/ChatService";
import ChannelService from "../../../../../services/ChannelService";

class ChatsBar extends React.Component {
  constructor( props ) {
    super( props );
    const { currentFilters } = props;

    this.state = {
      channelsSearchOpened: false,
      createdAt: 'ASC',
      filters: {
        service: currentFilters.chatFilterLastService ? Number( currentFilters.chatFilterLastService ) : null,
        category: currentFilters.chatFilterLastCategory,
        words: currentFilters.chatFilterLastWords,
        from: currentFilters.chatFilterLastFrom,
        assignedToMe: currentFilters.filterMy,
      }
    };

    this.reloadData = this.reloadData.bind( this );
    this.toggleOrderFilter = this.toggleOrderFilter.bind( this );
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.reloadChatDate && this.props.reloadChatDate !== nextProps.reloadChatDate ) {
      this.setState( { reloadWarning: true } )
    }
  }

  reloadData( reload = true, isPrev = false ) {
    const { filters, filterText } = this.state;

    this.props.onReloadData( {
      chatService: filters.service,
      chatCategory: filters.category,
      chatWords: filters.words,
      chatFrom: filters.from,
      current_agent: filters.assignedToMe,
      allCriteriaChatCustomer: filterText,
      createdAtOrder: this.state.createdAt,
      reloadPagination: reload,
      search: 1,
      isPrev: isPrev,
      toggleLoading: true
    } );

    if( reload ) {
      animateScrollTo( 0, {
        element: $( '#channelsBody' )[0],
        maxDuration: 1500,
      } )
    }
  }

  toggleOrderFilter() {
    this.setState( { createdAt: this.state.createdAt === 'DESC' ? 'ASC' : 'DESC' }, this.reloadData )
  }

  toggleChannelsSearchModal = () => {
    this.setState( { channelsSearchOpened: !this.state.channelsSearchOpened } )
  };

  submitFilters = ( values = {}, toggleModal = true ) => {
    const filters = values;
    if( values.category && values.category.length && values.category[0].id ) {
      filters.category = _.map( values.category, 'id' )
    }

    this.props.updateUser( {
      chatFilterLastService: filters.service,
      chatFilterLastCategory: filters.category,
      chatFilterLastWords: filters.words,
      chatFilterLastFrom: filters.from,
    } );

    this.setState( { filters }, () => this.reloadData() );
    if( toggleModal ) {
      this.toggleChannelsSearchModal();
    }
  };

  changeStatus = ( e, val ) => {
    const { toggleLoading, toggleAlertError, changeStatusWebsocket, websocketStatus } = this.props;

    const status = val === 0 ? 'on' : 'off';
    if( status === websocketStatus ) return;

    toggleLoading( true );
    if( val === 0 ) {
      ChatService.getOperatorCredentials().then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) return toggleAlertError( response.errors );

        changeStatusWebsocket( {
          status: 'on',
          data: response.data
        } )
      } )
    } else {
      ChannelService.getChannels( {
        'filters[type]': 'chat',
        'filters[status]': 'open',
      } ).then( ( response ) => {
        toggleLoading( false );
        if( response.errors ) return toggleAlertError( response.errors );
        if( response.data.total > 0 ) return toggleAlertError( 'You have to close opened chats before going offline' );

        changeStatusWebsocket( { status: 'off' } )
      } )
    }
  };

  renderChannelItem( item, index, firstItem = false ) {
    const { loadChat, selectedChats, toggleSelectedChats, activeChat, intl } = this.props;
    const isSelected = _.find( selectedChats, { id: item.id } );
    return (
      <div key={index}
           className={firstItem || isSelected || activeChat && activeChat.id === item.id ? 'bg-color-body' : null}
           onClick={() => loadChat( item.id )}
      >
        <ListItem
          id={`channel-${item.id}`}
          style={{ borderTop: '1px solid #e5e5e5' }}
          innerDivStyle={{ paddingBottom: 8, paddingTop: 8, width: '100%' }}
          children={
            <div className="row" key={index}>
              <div className="col-md-2 pl-0 text-center">
                <Avatar src={_.get( item, 'webPathThumbnail' )}/>
                <div className="pt-1 d-flex align-items-center justify-content-center">
                  <i data-tip={intl.formatMessage( { id: "open" } )}
                     className={classNames( 'fa fa-circle text-small', { 'color-orange': item.status === 'open' } )}/>
                  <ReactTooltip place="bottom" type="dark" effect="solid"/>
                </div>
              </div>
              <div className="col-md-10">
                <div className="row">
                  <div className="col-md-9 col-lg-10 col-xl-11 p-0">
                    {_.get( item, 'name' )}
                    <span className="color-app-light-2 d-block text-normal mt-1 text-truncate">
                        {item.snippet}
                      </span>
                  </div>
                  <div className="col-md-3 col-lg-2 col-xl-1 p-0">
                    <Checkbox
                      uncheckedIcon={<div style={{ padding: 3 }}><img src={checkbox}/></div>}
                      checked={!!isSelected}
                      onClick={( event ) => {
                        event.stopPropagation();
                        toggleSelectedChats( item, event.target.checked )
                      }}/>
                  </div>
                </div>
                <div className="row pt-3">
                  <div className="col-12 col-xl-auto p-0">
                    <div className="text-small font-italic">
                      <i className="icon-headset mr-1"/>
                      <span>{item.agent ? `${item.agent.name || ''} ${item.agent.lastname || ''}` :
                        <Translate id="pendingAssignment"/>}
                      </span>
                    </div>
                  </div>
                  <div className="col-auto col-xl text-right pr-1 pl-0">
                    <span className="text-primary text-small text-muted">
                      {_.get( item, 'socialUpdateTime' ) &&
                      moment( _.get( item, 'socialUpdateTime' ) ).format( 'DD/MM/YYYY h:mm A' )
                      }
                    </span>
                  </div>
                </div>
              </div>
            </div>
          }
        />
        <Divider/>
      </div>
    )
  }

  render() {
    const { onReloadChats, data, options, selectedChats, toggleAllChats, offset, intl, websocketStatus } = this.props;

    const { filters } = this.state;
    const filtersHasValue = filters && ( filters.assignedToMe || filters.service || ( filters.category && filters.category.length ) ||
      filters.words || filters.status || filters.from || filters.selectedSocialType
    );

    return (
      <div className="box box-default m-0 no-shadow border-right border-gray-1 no-border-radius">
        <div className="box-header p-0 border-bottom-0">

          <div className="d-flex justify-content-between align-items-center pt-1 pb-2 px-2"
               style={{ boxShadow: '0 2px 4px 0 rgba(0,0,0,0.10)' }}>

            <Form onSubmit={( values ) => {this.setState( { filterText: values.search }, () => this.reloadData() )}}>
              {( { submitForm } ) => (
                <form onSubmit={submitForm} className="col-md p-0">
                  <div className="channels-search">
                    <Text field="search" className="form-control" placeholder="typeToSearch" append
                          prefix={<i className="icon-search"/>}/>
                  </div>
                </form>
              )}
            </Form>

            <div className="col-md-auto pr-0">
              <button data-tip={intl.formatMessage( { id: "FilterSection" } )}
                      className={classNames( 'btn btn-fixed-sm', {
                        'btn-secondary': filtersHasValue,
                        'btn-outline-secondary': !filtersHasValue,
                      } )}
                      onClick={this.toggleChannelsSearchModal}
                      style={{ borderRadius: 4, marginRight: 2 }}>
                <i className="fa fa-filter text-normal"/>
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </button>

              <button data-tip={intl.formatMessage( { id: "OrderTheCases" } )}
                      className="btn btn-outline-secondary btn-fixed-sm" onClick={this.toggleOrderFilter}
                      style={{ borderRadius: 4, marginRight: 2 }}>
                <i className="fa fa-sort"/>
                <ReactTooltip place="bottom" type="dark" effect="solid"/>
              </button>
            </div>
          </div>

          <div className="py-2 px-2 row">
            <div className="col-auto">
              <span className={classNames( 'font-weight-light pointer', {
                'color-app-light': !this.state.reloadWarning,
                'color-danger': this.state.reloadWarning
              } )} onClick={() => {
                this.setState( { reloadWarning: false } );
                onReloadChats()
              }}>
              <Translate id="refreshList"/>
            </span>
              <span className="color-app-light font-weight-light"> | </span>
              <span className="color-app-light font-weight-light pointer" onClick={toggleAllChats}>
              <Translate
                id={data ? _.intersectionBy( selectedChats, data, 'id' ).length === data.length ? 'unselectAll' : 'selectAll' : 'selectAll'}/>
            </span>
            </div>

            <div className="col-xl text-xl-right">
               <span className={classNames( 'font-weight-light pointer', {
                 'color-app-light': offset === 0,
               } )}
                     onClick={() => offset >= 6 ? this.reloadData( false, true ) : {}}>
                <i className="fa fa-angle-double-left mr-1"/>
                <Translate id="prevPage"/>
              </span>
              {' '}
              <span className="color-app-light font-weight-light">-{Math.ceil( offset / 6 ) + 1}-</span>
              {' '}
              <span className={classNames( 'pointer font-weight-light', {
                'color-app-light': !data || data.length < 6 || ( ( Math.ceil( offset / 6 ) + 1 ) * 6 ) >= this.props.totalChats,
              } )}
                    onClick={() => data && ( data.length >= 6 && ( ( Math.ceil( offset / 6 ) + 1 ) * 6 ) < this.props.totalChats ) ? this.reloadData( false ) : {}}>
              <Translate id="nextPage"/>
              <i className="fa fa-angle-double-right ml-1"/>
            </span>
            </div>
          </div>
        </div>

        <div className="box-body box-body-chats py-0 pl-1 pr-0" ref="body" id="channelsBody">
          <List style={{ padding: 0 }}>
            {_.map( data, ( item, index ) => this.renderChannelItem( item, index, false ) )}
          </List>
        </div>

        <div className="bg-color-info text-white py-2">
          <div className="d-flex align-items-center justify-content-center">
            <span className="pr-1">Status:</span>
            <DropDownMenu value={websocketStatus} underlineStyle={{ borderTop: 0 }} style={{ height: 20 }}
                          labelStyle={{
                            height: 20,
                            lineHeight: '20px',
                            paddingLeft: 0,
                            paddingRight: 20,
                            color: websocketStatus === 'on' ? '#42D358' : '#EF5350',
                            fontWeight: 'normal'
                          }}
                          iconStyle={{ height: 20, width: 20, padding: 0, right: 0, top: -2 }}
                          selectedMenuItemStyle={{ color: 'rgba(0, 0, 0, 0.87)' }}
                          onChange={this.changeStatus}
            >
              <MenuItem value="on" primaryText="Online"/>
              <MenuItem value="off" primaryText="Offline"/>
            </DropDownMenu>
          </div>
        </div>

        <ChannelsSearch open={this.state.channelsSearchOpened}
                        onClose={this.toggleChannelsSearchModal}
                        options={options}
                        onSubmit={this.submitFilters}
                        filters={filters}
        />
      </div>
    )
  }
}

const mapStateToProps = ( state ) => ( {
  reloadChatDate: state.channelDetail.reloadChatDate,
  websocketStatus: state.websocket.status,
} );

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( msg ) => {
    dispatch( toggleAlertError( msg ) );
  },
  updateUser: ( data ) => {
    dispatch( updateUser( data ) );
  },
  changeStatusWebsocket: ( status ) => {
    dispatch( changeStatusWebsocket( status ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( injectIntl( ChatsBar ) );



// WEBPACK FOOTER //
// ./routes/app/components/Agent/ChatsBar/index.js